import { provincesCanada } from './provinces.ca';
import { provincesUsa } from './provinces.us';

export interface Province {
    code: string;
    name: string;
    country: string;
    localization?: {};
}

export const provinces = {
    CA: provincesCanada,
    US: provincesUsa
};
